import React from 'react';

import Image from '../../images/work-image-s3.jpg'
import { Link } from 'react-router-dom';

const WorkSectionS3 = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10,0)
    }
    return (
        <section className={"" +props.hclass}>
            <div className="container-fluid p-0">
                <div className="wraper">
                    <div className="left-content">
                        <h2 className="scroll-text-animation" data-animation="fade_from_right">How We Manage Renovations</h2>
                        <ul className="scroll-text-animation" data-animation="fade_from_right">
                            <li><Link onClick={ClickHandler} to="#">1. Consultation & Deal</Link></li>
                            <li><Link onClick={ClickHandler} to="#">2. Design & Planning</Link></li>
                            <li><Link onClick={ClickHandler} to="#">3. Start Working</Link></li>
                            <li><Link onClick={ClickHandler} to="#">4. Renovation</Link></li>
                            <li><Link onClick={ClickHandler} to="#">5. Completion</Link></li>
                        </ul>
                    </div>
                    <div className="right-image">
                        <img src={Image} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WorkSectionS3;